import CloseIcon from '@mui/icons-material/Close'
import EmailIcon from '@mui/icons-material/Email'
import LogoutIcon from '@mui/icons-material/Logout'
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts'
import PersonIcon from '@mui/icons-material/Person'
import {
  Backdrop,
  Box,
  SpeedDial,
  SpeedDialAction,
  SpeedDialIcon,
  styled,
} from '@mui/material'
import { red } from '@mui/material/colors'
import {
  Channels,
  dispatch,
  Events,
  Sources,
} from '@npm-client-frontends/client-frontends-custom-events'
import { useState } from 'react'
import goToLocation from '../../utils/goToLocation'

const StyledSpeedDial = styled(SpeedDial)(() => ({
  position: 'absolute',
  top: -15,
  right: -20,
  '& .MuiSpeedDial-fab.MuiButtonBase-root': {
    width: 30,
    height: 30,
    minHeight: 0,
    backgroundColor: '#fff',
    color: '#303c64',
  },
  '& .MuiSpeedDialAction-staticTooltip': {
    whiteSpace: 'nowrap',
    '& .MuiSpeedDialAction-staticTooltipLabel': {
      fontSize: 14,
      padding: '4px 10px',
    },
  },
  '& .MuiSpeedDialAction-fab, & .MuiSpeedDialAction-fab:hover': {
    backgroundColor: '#303c64',
    color: '#fff',
  },
  '& .MuiSpeedDialAction-fab.sign-out-button': {
    backgroundColor: red[500],
    color: '#fff',
  },
}))

export const HeaderMenuButton = () => {
  const [open, setOpen] = useState(false)

  const toggleMenu = () => setOpen((prev) => !prev)

  const handleClickUserSettings = () => {
    goToLocation('/account')
  }

  const handleClickContactUs = () => {
    window.open('mailto:help@newprojectmedia.com')
  }

  const handleClickSignOut = () => {
    dispatch(Channels.AUTH, Sources.NAV, Events.LOGOUT)
    sessionStorage.setItem('preLoginRoute', '/')
  }

  return (
    <Box sx={{ flexGrow: 0, position: 'relative', width: 40 }}>
      <Backdrop open={open} />
      <StyledSpeedDial
        ariaLabel="Account Menu"
        icon={<SpeedDialIcon icon={<PersonIcon />} openIcon={<CloseIcon />} />}
        open={open}
        onClick={toggleMenu}
        direction="down"
      >
        <SpeedDialAction
          icon={<ManageAccountsIcon />}
          tooltipTitle="Account Settings"
          tooltipOpen
          onClick={handleClickUserSettings}
          data-testid="account-settings-button"
        />
        <SpeedDialAction
          icon={<EmailIcon />}
          tooltipTitle="Contact Us"
          tooltipOpen
          onClick={handleClickContactUs}
        />
        <SpeedDialAction
          icon={<LogoutIcon />}
          tooltipTitle="Sign Out"
          tooltipOpen
          onClick={handleClickSignOut}
          className="sign-out-button"
        />
      </StyledSpeedDial>
    </Box>
  )
}
